import type { InputMaybe } from "@/lib/gql/__generated__/graphql";

import type { ForNodeType } from "@/components/features/_model/types";

type Props = {
	saleStartBeforeDate: ForNodeType<InputMaybe<number> | undefined> | undefined;

	onSetViewModel: (
		values: {
			key: "saleStartBeforeDate";
			value: ForNodeType<InputMaybe<number> | undefined>;
		}[],
	) => void;
};

export const useOptionSaleStartBeforeDate = ({ saleStartBeforeDate, onSetViewModel }: Props) => {
	const onSetSaleStartBeforeDate = (input: number | undefined) => {
		onSetViewModel([{ key: "saleStartBeforeDate", value: { isEdited: true, value: input } }]);
	};

	const isEdited = saleStartBeforeDate?.isEdited ?? false;
	const hasError = Boolean(saleStartBeforeDate?.error || false);

	return {
		isEdited,
		hasError,

		saleStartBeforeDate,
		onSetSaleStartBeforeDate,
	};
};
